import React, { useState, useEffect } from "react";

import Date from "../../super_dashboard/components/Date";
import SelectLabels from "../../components/SelectLabels";
import { managerAxios } from "../../axiosInstance";
import { updateData, getDataById } from "../../utility/managerApi";
import DeliveryTimeInput from "../../components/DeliveryTimeInput";
import CancelIcon from "@mui/icons-material/Cancel";

function EditProduct({
  singleData,
  setSingleData,
  fetchProducts,
  setEdittab,
  currentPage,
}) {
  const [file] = useState(null);
  const [loading, setLoading] = useState(false);

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [, setSelectedSubcategory] = useState(null);
  const [categoryData, setCategoryData] = useState([]);
  const [subsingleData, setSubsingleData] = useState([]);

  const fetchProductData = async (page) => {
    try {
      const response = await managerAxios.get("categories");
      const data = response?.data?.data;
      setCategoryData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSingleFile = async (id, setEditTab = false) => {
    const response = await getDataById("categories/show/", id);
    setSubsingleData(response?.data?.data?.sub_categories);
  };
  useEffect(() => {
    if (selectedCategory != null) {
      handleSingleFile(selectedCategory);
    }
  }, [selectedCategory]);
  useEffect(() => {
    fetchProductData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setSingleData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };

  // const handleFileChange = (e) => {
  //   setSingleData((prevData) => ({
  //     ...prevData,
  //     product_image: e.target.files[0], // Correct the key here
  //   }));
  // };

  const handleDateChange = (year, month, day, type) => {
    setSingleData((prevData) => ({
      ...prevData,
      [type]: `${year}-${month}-${day}`,
    }));
  };

  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
    setSingleData((prevData) => ({
      ...prevData,
      cat_id: value, // Update the corresponding field in state
    }));
  };

  const handleSubcategoryChange = (value) => {
    setSelectedSubcategory(value);
    setSingleData((prevData) => ({
      ...prevData,
      sub_cat_id: value, // Update the corresponding field in state
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    // Log singleData before submission to check its content
    setLoading(true);
    const keysToExtract = [
      "store",
      "warehouse",
      "supplier",
      "cat_id",
      "sub_cat_id",
      "product_name",
      "password",
      "sku",
      "barcode",
      "available_quantity",
      "price",
      "manufacturing_date",
      "expiring_date",
      "product_image",
      "description",
      "is_unlimited",
      "delivery_time",
    ];
    const newSingleData = Object.keys(singleData).reduce((result, key) => {
      if (keysToExtract.includes(key)) {
        result[key] = singleData[key];
      }
      return result;
    }, {});

    newSingleData.is_unlimited = !!singleData.is_unlimited;
    newSingleData.delivery_time = singleData.delivery_time || 0;
    if (newSingleData.is_unlimited) {
      delete newSingleData.available_quantity;
    } else if (!(Number(newSingleData.available_quantity) > 0)) {
      setLoading(false);
      alert("Quantity must be greater than 0 for limited-stock products.");
      return;
    }

    if (newSingleData.hasOwnProperty("available_quantity")) {
      newSingleData.quantity = newSingleData.available_quantity;
      delete newSingleData.available_quantity; // Remove available_quantity after renaming
    }

    const response = await updateData(
      "products/update/",
      singleData?.id,
      newSingleData
    );
    let errorCheck = response?.response?.data?.error;

    if (errorCheck) {
      setLoading(false);
    } else {
      fetchProducts(currentPage);
      setEdittab(false);
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleEditSubmit} className=" bg-white p-6 rounded-md ">
      <div className="flex justify-end">
        <CancelIcon
          className="cursor-pointer"
          onClick={() => setEdittab(false)}
        />
      </div>
      <h4 className="text-center font-semibold text-xl">
        Edit Product Details 
      </h4>
      <div className="flex">
        {file && (
          <div className="w-16 h-16">
            <img
              src={file.preview}
              alt={file.name}
              className="w-full h-auto object-cover rounded-lg mb-2"
            />
          </div>
        )}
      </div>
      <div className="flex flex-col lg:flex-row gap-x-4 gap-y-4  flex-wrap ">
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="store">Store</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="Store"
            type="text "
            name="store"
            // id="email"
            value={singleData.store}
            onChange={handleChange}
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="store">Warehouse</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="Warehouse"
            type="text "
            name="warehouse"
            // id="email"
            value={singleData.warehouse}
            onChange={handleChange}
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="store">Supplier</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="Supplier"
            type="text "
            name="supplier"
            // id="email"
            value={singleData.supplier}
            onChange={handleChange}
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="Manufacturing Date">Category</label>
          <SelectLabels
            categoryData={categoryData}
            text="Select a Category"
            valueKey="id"
            labelKey="cat_name"
            onSelectChange={handleCategoryChange}
            previousValue={singleData?.cat_id}
            prevId={singleData?.category?.id}
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="Manufacturing Date">Subcategory</label>
          <SelectLabels
            categoryData={subsingleData}
            text="Select Sub-category"
            valueKey="id"
            labelKey="sub_cat_name"
            onSelectChange={handleSubcategoryChange}
            // previousValue={categoryData?.sub_categories?.id}
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="store">Product Name</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="Product Name"
            type="text "
            name="product_name"
            // id="email"
            value={singleData?.product_name}
            onChange={handleChange}
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="store">SKU</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="SKU"
            type="text "
            name="sku"
            // id="email"
            value={singleData?.sku}
            onChange={handleChange}
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="store">Barcode</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="Barcode"
            type="text "
            name="barcode"
            // id="email"
            value={singleData?.barcode}
            onChange={handleChange}
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="store">Quantity </label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="Quantity"
            type="number"
            min="1"
            name="available_quantity"
            value={singleData?.is_unlimited ? "" : singleData?.available_quantity}
            onChange={handleChange}
            disabled={!!singleData?.is_unlimited}
          />
          <label className="flex items-center gap-2 mt-1 text-sm cursor-pointer">
            <input
              type="checkbox"
              checked={!!singleData?.is_unlimited}
              onChange={(e) =>
                setSingleData((prev) => ({
                  ...prev,
                  is_unlimited: e.target.checked,
                }))
              }
            />
            Unlimited stock
          </label>
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label>Delivery Time</label>
          <DeliveryTimeInput
            seconds={singleData?.delivery_time}
            onChange={(seconds) =>
              setSingleData((prev) => ({ ...prev, delivery_time: seconds }))
            }
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/ lg:max-w-[32%]">
          <label htmlFor="store">Price </label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="Price"
            type="number"
            name="price"
            // id="email"
            value={singleData?.price}
            onChange={handleChange}
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="Manufacturing Date">Manufacturing Date</label>
          <Date
            onDateChange={handleDateChange}
            // type={"manufacturing_date"}
            existingDate={singleData?.manufacturing_date}
            className={"lg:w-full"}
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="Expiring Date">Expiring Date</label>
          <Date
            onDateChange={handleDateChange}
            type={"expiring_date"}
            existingDate={singleData?.expiring_date}
            className={"lg:w-full"}
          />
        </div>
        <div className="w-[99%] flex flex-col ">
          <label htmlFor="">Product Description</label>
          <textarea
            name="description"
            id="product_description"
            className="border-2 p-2"
            placeholder="Product description"
            onChange={handleChange}
            value={singleData?.description}
          ></textarea>
        </div>
      </div>

      <div className="flex justify-center my-6 text-white font-medium text-xl p-3 bg-darkblue rounded-lg">
        <button type="submit" className="w-full h-full" disabled={loading}>
          {loading ? "Updating..." : "Update Product"}
        </button>
      </div>
    </form>
  );
}

export default EditProduct;
